import React from "react";

const FieldError = ({ label }) => <span className="d-block text-danger mt-1">{label}</span>;

export default FieldError;



// WEBPACK FOOTER //
// ./src/app/auth/FieldError.js